import { invoicingService } from "./repository";
import qs from "qs";

const resource = "/v1/kela";

export default {
    async search(params) {
        return invoicingService.get(`${resource}/batches`, {
            params,
            paramsSerializer: p => qs.stringify(p, { indices: false })
        });
    },
    async getSummary() {
        return invoicingService.get("/statistics/kela/summary");
    },
    async getTransportEventStatuses(transportEventId) {
        return invoicingService.get(`${resource}/transport-event-statuses`, {
            params: { transportEventId }
        });
    }
};
